import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/libs/util'
import { saveErrorLogger } from '@/api/data'
import { getUserMenuTree } from '@/api/user'
import router from '@/router'
import { mainRouer, rs, errorRouter } from '@/router/routers'
import config from '@/config'
import { Spin } from 'view-design'
const { homeName } = config

// const getSelectMenu = (data,)=>{

// }

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter((item) => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    menuRules: [],
    errorList: [],
    routerList: [...rs],
    hasReadErrorPage: false
  },
  getters: {
    menuList: (state, getters, rootState) => {
      return getMenuByRouter(state.routerList, rootState.user.access)
    },
    getRouters:(state) => state.routerList,
    errorCount: (state) => state.errorList.length,
    getMenuRules:(state) => (path) => {
      const menu = path.split('/')
      let li = []
      try {
        li = state.menuRules.find(i => i.menuPath.includes(menu[0])).children.find(i => i.menuPath.includes(menu[1])).children
      } catch (e) {
        li = []
      }
      return li
    }
  },
  mutations: {
    setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName)
    },
    setRouterList(state, routes) {
      state.routerList = routes
    },
    setMenuRules(state, rules) {
      state.menuRules = rules
    },
    setTagNavList(state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else tagList = getTagNavListFromLocalstorage() || []
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex((item) => item.name === homeName)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag(state, route) {
      let tag = state.tagNavList.filter((item) => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag(state, { route, type = 'unshift' }) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router)
        else {
          if (router.name === homeName) state.tagNavList.unshift(router)
          else state.tagNavList.splice(1, 0, router)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal(state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    addError(state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus(state, status = true) {
      state.hasReadErrorPage = status
    }
  },
  actions: {
    addRouterList({ commit }) {
      Spin.show()
      getUserMenuTree().then(r => {
        commit('setMenuRules', r.data)
        const rs1 = mainRouer.filter(el => {
          const routeIndex = r.data.findIndex(i => i.menuPath === el.path)
          if (routeIndex>-1) {
            el.children = el.children.filter(i => {
              return !!r.data[routeIndex].children.find(a => a.menuPath === i.path)
            })
          }
          return routeIndex>-1
        })
        router.addRoutes([...rs1, ...errorRouter])
        commit('setRouterList', [...rs, ...rs1, ...errorRouter])
        Spin.hide()
      }).catch(e => {
        commit('setRouterList', [...rs, ...errorRouter])
        Spin.hide()
      })
    },
    addErrorLog({ commit, rootState }, info) {
      if (!window.location.href.includes('error_logger_page')) { commit('setHasReadErrorLoggerStatus', false) }
      const {
        user: { token, userId, userName }
      } = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      saveErrorLogger(info).then(() => {
        commit('addError', data)
      })
    }
  }
}
